import {
  on,
  each,
  removeClass,
  setCookie,
  getCookie,
} from '../helpers/shortcuts';
import S from './shared';
import { lockViewport, unlockViewport } from '../helpers/viewport-lock';

export default () => {
  const appData = window.APP_DATA || {};
  const overlayLinks = document.querySelectorAll(
    '[href*="/popup/"], [href*="post_type=popup"], [data-overlay-trigger]',
  );
  const overlays = document.querySelectorAll('.c-overlay');
  const newsletterOverlay = document.querySelector('.c-overlay--newsletter');

  const showOverlay = overlay => {
    overlay.classList.add(S.CSS.active);
    setTimeout(() => {
      overlay.setAttribute('aria-hidden', 'false');
    }, 500);
    lockViewport(overlay);
    S.isOverlay = true;
  };

  const showContent = (overlay, content) => {
    removeClass(content.parentNode.children, S.CSS.active);
    each(content.parentNode.children, child => {
      child.setAttribute('aria-hidden', 'true');
    });
    content.classList.add(S.CSS.active);
    content.setAttribute('aria-hidden', 'false');
  };

  const hideOverlay = overlay => {
    if (overlay.getAttribute('aria-hidden') === 'true') {
      return;
    }

    S.isOverlay = false;
    overlay.classList.remove(S.CSS.active);
    overlay.setAttribute('aria-hidden', 'true');

    if (overlay.classList.contains('c-overlay--newsletter')) {
      if (appData.showOverlay) {
        setCookie(`newsletter-dismissed-${appData.pageId}`, 1, 1);
      } else {
        setCookie('newsletter-dismissed', 1, 1);
      }
    }

    unlockViewport(overlay);
  };

  on('click', overlayLinks, event => {
    const link = event.currentTarget;
    let overlayContent;

    if (link.dataset.overlayTrigger) {
      overlayContent = document.querySelector(
        `[data-overlay-id="${link.dataset.overlayTrigger}"]`,
      );
    } else {
      overlayContent = document.querySelector(
        `[data-overlay-url*="${link.getAttribute('href')}"]`,
      );
    }

    if (overlayContent !== null) {
      const overlay = overlayContent.closest('.c-overlay');
      showOverlay(overlay);
      showContent(overlay, overlayContent);
      event.preventDefault();
    }
  });

  each(overlays, overlay => {
    const closeButtons = overlay.querySelectorAll('[data-overlay-close]');
    const body = overlay.querySelector('.c-overlay__body');
    const next = overlay.querySelector('.c-overlay__nav--next');
    const prev = overlay.querySelector('.c-overlay__nav--previous');
    const slides = overlay.querySelectorAll('.c-overlay__content');

    on('click', [...closeButtons, overlay], event => {
      event.preventDefault();
      event.stopPropagation();
      hideOverlay(overlay);
    });

    on('click', body, event => {
      event.stopPropagation();
    });

    if (next !== null) {
      on('click', next, event => {
        event.stopPropagation();
        event.preventDefault();

        const index = [].indexOf.call(
          slides,
          overlay.querySelector('.c-overlay__content.is-active'),
        );

        showContent(overlay, slides[(index + 1) % slides.length]);
      });
    }

    if (prev !== null) {
      on('click', prev, event => {
        event.stopPropagation();
        event.preventDefault();

        let index =
          [].indexOf.call(
            slides,
            overlay.querySelector('.c-overlay__content.is-active'),
          ) - 1;

        if (index < 0) {
          index = slides.length - 1;
        }

        showContent(overlay, slides[index]);
      });
    }
  });

  if (newsletterOverlay !== null) {
    const newsletterId =
      parseInt(
        newsletterOverlay.querySelector('[data-overlay-id]').dataset.overlayId,
        10,
      ) || 0;
    const wpcf7Elm = newsletterOverlay.querySelector('.wpcf7');
    const firewallButtons = document.querySelectorAll(
      'a[data-require-signup], [data-require-signup] a',
    );
    let newsletterSubmitted = getCookie(`newsletter-${newsletterId}`);
    const newsletterDismissed = getCookie('newsletter-dismissed');
    const newsletterPageDismissed = getCookie(
      `newsletter-dismissed-${appData.pageId}`,
    );
    let firewallLink = '';
    let firewallTarget = '';

    if (!newsletterSubmitted) {
      if (appData.showOverlay && !newsletterPageDismissed) {
        document.addEventListener('interaction', () => {
          showOverlay(newsletterOverlay);
        });
      } else if (!appData.showOverlay && !newsletterDismissed) {
        document.addEventListener('interaction', () => {
          setTimeout(() => {
            showOverlay(newsletterOverlay);
          }, 3000);
        });
      }
    }

    if (wpcf7Elm !== null) {
      wpcf7Elm.addEventListener('wpcf7mailsent', () => {
        setCookie(`newsletter-${newsletterId}`, 1, 31 * 12 * 10);
        if (firewallLink) {
          setTimeout(() => {
            if (firewallTarget !== '_blank') {
              window.location.href = firewallLink;
            } else {
              const windowRef = window.open(firewallLink, '_blank');

              if (!windowRef) {
                window.location.href = firewallLink;
              }
            }

            firewallLink = '';
            firewallTarget = '';
            hideOverlay(newsletterOverlay);
          }, 2000);
        }
      });
    }

    if (firewallButtons.length > 0) {
      on('click', firewallButtons, event => {
        newsletterSubmitted = getCookie(`newsletter-${newsletterId}`);

        if (!newsletterSubmitted) {
          event.preventDefault();
          firewallLink = event.currentTarget.href;
          firewallTarget = event.currentTarget.target;
          showOverlay(newsletterOverlay);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/overlay.js